import GenericCardHeader from "../GenericCardHeader/GenericCardHeader";
import { setCurrentHotspot } from "../../redux";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentHotspot, getHotspotName } from "../../redux/selectors";

import { HotspotBackButton } from "../HotspotBackButton/HotspotBackButton";
import { RightComponent } from "../HotspotMoreMenu/HotspotMoreMenu";
import HotspotThumbnail from "../HotspotThumbnail/HotspotThumbnail";

function HotspotCardTitle({ hotspotIndex, name }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        marginTop: "0.5rem",
      }}
    >
      <HotspotThumbnail
        hotspotIndex={hotspotIndex}
        // size={{ dw: 50, dh: 50 }}
      />{" "}
      {name}
    </div>
  );
}

export default function HotspotCardHeader() {
  const name = useSelector(getHotspotName);
  const hotspotIndex = useSelector(getCurrentHotspot);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setCurrentHotspot(null));
  };
  return (
    <GenericCardHeader
      leftComponent={HotspotBackButton}
      title={<HotspotCardTitle hotspotIndex={hotspotIndex} name={name} />}
      rightComponent={RightComponent}
      onClose={handleClose}
    />
  );
}
